import { render } from "./ListDataCutiApprove.vue?vue&type=template&id=aa8828a8"
import script from "./ListDataCutiApprove.vue?vue&type=script&lang=js"
export * from "./ListDataCutiApprove.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__